export const LOGIN_USER = 'login_user'
export const LOGIN_USER_SUCCESS = 'login_user_success'
export const LOGIN_USER_FAIL = 'login_user_fail'
export const LOGOUT_USER = 'logout_user'

export const RESET_DATA = 'reset_data'
export const FETCHING_DATA = 'fetching_data'
export const FETCH_DATA_SUCCESS = 'fetch_data_success'
export const FETCH_DATA_FAIL = 'fetch_data_fail'
export const UPDATE_DATA = 'update_data'
export const SET_FILTER_FIELD = 'set_filter_field'
export const SET_FILTER_VALUE = 'set_filter_value'
export const RESET_FILTER = 'reset_filter'

export const POSTING_FORM = 'posting_form'
export const POST_FORM_SUCCESS = 'post_form_success'
export const POST_FORM_FAIL = 'post_form_fail'
export const POSTING_CSV = 'posting_csv'
export const POST_CSV_SUCCESS = 'post_csv_success'
export const POST_CSV_FAIL = 'post_fail_success'
export const RESET_FORM = 'reset_form'

export const RESET_DETAILS = 'reset_details'
export const FETCHING_DETAILS = 'fetching_details'
export const FETCH_DETAILS_SUCCESS = 'fetch_details_success'
export const FETCH_DETAILS_FAIL = 'fetch_details_fail'

export const RESET_PUSH = 'reset_push'
export const FETCHING_PUSH = 'fetching_push'
export const FETCH_PUSH_SUCCESS = 'fetch_push_success'
export const FETCH_PUSH_FAIL = 'fetch_push_fail'
export const POSTING_PUSH = 'posting_push'
export const POST_PUSH_SUCCESS = 'post_push_success'
export const POST_PUSH_FAIL = 'post_push_fail'
export const SENDING_PUSH = 'sending_push'
export const SEND_PUSH_SUCCESS = 'post_push_fail'
export const SEND_PUSH_FAIL = 'post_push_fail'
export const DELETE_PUSH = 'delete_push'

export const RESET_CHATLIST = 'reset_chat_list'
export const FETCHING_CHATLIST = 'fetching_chat_list'
export const FETCH_CHATLIST_SUCCESS = 'fetch_chat_list_success'
export const FETCH_CHATLIST_FAIL = 'fetch_chat_list_fail'
export const FILTER_CHATLIST = 'filter_chat_list'
export const FETCHING_CHAT = 'fetching_chat'
export const FETCH_CHAT_SUCCESS = 'fetch_chat_success'
export const FETCH_CHAT_FAIL = 'fetch_chat_fail'
export const RESET_CHAT = 'reset_chat'
export const POST_MESSAGE = 'post_message'
export const FETCH_ROOM_SUCCESS = 'fetch_room_success'
export const FETCH_WAITING_SUPPORT_COUNT = 'fetch_waiting_support_count'

export const TOGGLE_VISIBILITY = 'toggle_visibility'

export const SHOW_TOAST = 'show_toast'
export const HIDE_TOAST = 'hide_toast'



// WEBPACK FOOTER //
// ./src/actions/types.js